import React from 'react';
import './svg.css';

const MinusIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.1393 10.2002H3.84766" stroke="#08081B" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
    </svg>
  )
}

export default MinusIcon;